export default __webpack_public_path__ + "static/img/court_logo.a522040.svg";